<div
    [id]="radioButtonGroupId"
    class="main__container"
    [ngClass]="inputStyle">
    <label
        *ngIf="label"
        for="{{ radioButtonGroupId }}"
        >{{ label }}</label
    >
    <div
        *ngFor="let option of options"
        class="radio__button">
        <p-radioButton
            [attr.sera-read-only]="readOnly ? '' : null"
            [disabled]="isDisabled || readOnly ? true : option.disabled ? true : false"
            [inputId]="option.key + radioButtonGroupId"
            [style]="style"
            name="option"
            [value]="option.key"
            [(ngModel)]="value"
            (onClick)="selectionChanged.emit(value)"></p-radioButton>
        <div class="label__container">
            <label
                [for]="option.key + radioButtonGroupId"
                [ngClass]="{ 'p-disabled': isDisabled && !readOnly }"
                >{{ option.name | translate }}</label
            >
        </div>
    </div>
</div>
